import { gql } from 'graphql-tag';

export const CREATE_BOOKING = gql`
  mutation createBooking(
    $bookingInput: BookingInputType!
    $paymentDetailsInput: PaymentDetailsInputType!
  ) {
    createBooking(bookingInput: $bookingInput, paymentDetailsInput: $paymentDetailsInput) {
      booking {
        member {
          email
          firstname
          lastname
          preferredName
        }
        locationId
        bookingSource
        skuId
        transactionId
        timeSlot {
          machineId
          utcStart
          utcEnd
        }
      }
      message
      status
    }
  }
`;
